module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-01.dfd65c69.svg";